module.exports = __webpack_public_path__ + "img/57.8c51dfab.webp";